(function (global) {
  'use strict';
  function offerVariant(mapping) {
    if (!mapping) return null;
    if (String(mapping.key || '').trim()) return global.ClutchLoopAnchors.resolve(mapping).variant;
    return (mapping.variants || []).find(function (variant) { return variant.available; }) || null;
  }
  // Presentation only: retain the real Shopify price for transaction checks.
  function displayOffer(mapping, automatic, fallbackPercent) {
    var variant = offerVariant(mapping);
    if (!variant) return null;
    var actual = Number(variant.price);
    var original = Math.max(actual, Number(variant.compare_at_price) || 0);
    var percent = automatic ? Number(mapping.displayDiscount == null ? fallbackPercent : mapping.displayDiscount) : 0;
    if (!Number.isFinite(percent) || percent < 0 || percent > 100) percent = 0;
    // A catalog sale already at the offer price must not receive the discount twice.
    var shown = percent ? Math.min(actual, Math.round(original * (100 - percent) / 100)) : actual;
    return Object.assign({}, variant, { price: shown, compare_at_price: original, actualPrice: actual });
  }
  function mount(node, refresh, money) {
    var config = JSON.parse(node.querySelector('[data-checkout-config]').textContent);
    function elements(selector) {
      return node.querySelectorAll ? Array.from(node.querySelectorAll(selector)) : [node.querySelector(selector)].filter(Boolean);
    }
    elements('[data-checkout-part-config]').forEach(function (script) {
      var part = JSON.parse(script.textContent);
      Object.keys(part).forEach(function (key) {
        config[key] = part[key] && typeof part[key] === 'object' && !Array.isArray(part[key])
          ? Object.assign({}, config[key], part[key]) : part[key];
      });
    });
    if (global.ClutchLoopCheckoutView) global.ClutchLoopCheckoutView.prepare(node);
    var selected = false, secondSelected = false, last = { lines: [], codes: [], total: 0, error: '' }, suggestion;
    var buttons = elements('[data-checkout-suggestion]');
    var button = buttons[0] || global.document.createElement('button');
    function el(tag, cls, text) { var n = document.createElement(tag); n.className = cls; if (text != null) n.textContent = text; return n; }
    function text(key, fallback) { return (config.texts || {})[key] || fallback; }
    function add() { if (suggestion) suggestion(); }
    buttons.forEach(function (b) { b.addEventListener('click', add); });
    return {
      group: 'checkout-' + config.id,
      codes: [config.giftCode].filter(Boolean),
      current: function () { return last; },
      cleanup: function () { buttons.forEach(function (b) { b.removeEventListener('click', add); }); },
      update: function (context) {
        last = { lines: [], codes: [], total: 0, error: '' };
        last.automatic = !!config.automatic;
        var charge = displayOffer(config.charge, config.automatic, config.charge && /^chargeloop$/i.test(String(config.charge.title || '').trim()) ? 40 : 0);
        var second = displayOffer(config.shippingOffer, config.automatic, 0);
        if (selected && !charge) { selected = false; last.error = 'ChargeLoop is unavailable. Please choose another add-on.'; }
        if (selected && charge) {
          last.total = Number(charge.price);
          last.lines.push({ id: charge.id, quantity: 1, role: 'charge', unit: charge.actualPrice, original: charge.actualPrice, code: '' });
        }
        if (secondSelected && !second) { secondSelected = false; last.error = 'The second add-on is unavailable. Please choose another add-on.'; }
        if (secondSelected && second) {
          last.total += Number(second.price);
          last.lines.push({ id: second.id, quantity: 1, role: 'shipping-offer', unit: second.actualPrice, original: second.actualPrice, code: '' });
        }
        var total = context.total + last.total, value = context.value + last.total;
        if (selected && charge) value += Math.max(0, Number(charge.compare_at_price || 0) - Number(charge.price));
        if (secondSelected && second) value += Math.max(0, Number(second.compare_at_price || 0) - Number(second.price));
        var thresholds = config.thresholds;
        if (!(thresholds.discount > 0 && thresholds.shipping > thresholds.discount && thresholds.gift > thresholds.shipping && thresholds.max > thresholds.gift)) {
          last.error = 'Set reward amounts in increasing order: Discount, Shipping, Gift, Line maximum.';
          thresholds = { discount: 55, shipping: 70, gift: 100, max: 120 };
        }
        var products = context.products.slice();
        if (selected) products.push({ label: config.charge.title, cents: Number(charge.price), swatches: [], remove: function () { selected = false; refresh(); } });
        if (secondSelected) products.push({ label: config.shippingOffer.title, cents: Number(second.price), swatches: [], remove: function () { secondSelected = false; refresh(); } });
        if (config.enableGift && total >= thresholds.gift * 100) {
          var gift = global.ClutchLoopAnchors.resolve(config.gift).variant;
          if (!gift || (!config.automatic && (!config.giftConfirmed || !config.giftCode))) last.error = 'Choose an available reward gift variant.';
          else {
            last.lines.push({ id: gift.id, quantity: 1, role: 'gift', unit: 0, original: Number(gift.price), code: config.giftCode });
            if (config.giftCode) last.codes.push(config.giftCode); value += Number(gift.price);
            products.push({ label: config.gift.title + ' · ' + text('giftSuffix', 'Free gift'), gift: true, cents: 0, swatches: [] });
          }
        }
        elements('[data-checkout-products]').forEach(function (list) {
        list.replaceChildren();
        products.forEach(function (p) {
          var item = el('li', 'clp-checkout__product' + (p.gift ? ' is-gift' : ''));
          item.appendChild(el('span', '', p.label));
          var swatches = el('ul', 'clp-checkout__variant-names');
          swatches.setAttribute('aria-label', p.label + ' variants');
          (p.swatches || []).forEach(function (s) {
            if (s.name) swatches.appendChild(el('li', '', s.name));
          });
          if (swatches.childElementCount) item.appendChild(swatches);
          if (p.remove) { var remove = el('button', 'clp-checkout__remove', '×'); remove.type = 'button'; remove.setAttribute('aria-label', 'Remove ' + p.label); remove.addEventListener('click', p.remove); item.appendChild(remove); }
          list.appendChild(item);
        });
        });
        var rewards = ['discount', 'shipping', 'gift'].map(function (key, i) {
          var reward = { key: key, amount: Number(thresholds[key]), label: config.labels[key], position: [18, 55, 86][i] };
          if (key === 'discount' && config.automatic && context.bundleDiscountPercent != null) {
            var percent = Number(context.bundleDiscountPercent);
            reward.unlocked = percent > 0;
            reward.pendingText = 'Choose a bundle';
            if (/^(?:discount|\$5\s*discount)$/i.test(String(reward.label).trim())) {
              reward.label = percent > 0 ? percent + '% Discount' : 'Bundle discount';
            }
          }
          return reward;
        });
        var next = rewards.find(function (r) { return r.unlocked == null && total < r.amount * 100; });
        var gap = next ? next.amount * 100 - total : 0;
        suggestion = null; button.hidden = true;
        var visibleOffer = null;
        function offerData(mapping, variant) { return { title: mapping.title, image: mapping.image, price: Number(variant.price), original: Number(variant.compare_at_price || variant.price) }; }
        var anchor = !config.stagedOffers && context.anchors.map(function (g) { return g.suggest(gap); }).find(Boolean);
        if (config.stagedOffers) {
          if (total < thresholds.shipping * 100 && !selected && charge) {
            suggestion = function () { selected = true; refresh(); };
            button.textContent = '+ ' + config.charge.title + ' · ' + money(charge.price);
            visibleOffer = offerData(config.charge, charge);
          } else if (total >= thresholds.shipping * 100 && total < thresholds.gift * 100 && !secondSelected && second) {
            suggestion = function () { secondSelected = true; refresh(); };
            button.textContent = '+ ' + config.shippingOffer.title + ' · ' + money(second.price);
            visibleOffer = offerData(config.shippingOffer, second);
          }
        }
        else if (anchor) { suggestion = anchor.add; button.textContent = '+ ' + anchor.label + ' · ' + money(anchor.price); visibleOffer = { title: anchor.label, price: anchor.price, original: anchor.price }; }
        else if (gap > 0 && gap <= 1500 && !selected && charge && Number(charge.price) >= gap) {
          suggestion = function () { selected = true; refresh(); };
          button.textContent = '+ ' + config.charge.title + ' · ' + money(charge.price);
          visibleOffer = offerData(config.charge, charge);
        }
        // A shopper can still remove ChargeLoop when the merchant omits the product-summary block.
        if ((selected || secondSelected) && !elements('[data-checkout-products]').length) {
          var removeSecond = secondSelected;
          suggestion = function () { if (removeSecond) secondSelected = false; else selected = false; refresh(); };
          button.textContent = 'Remove ' + (removeSecond ? config.shippingOffer.title : config.charge.title);
          visibleOffer = { title: button.textContent, price: 0, original: 0 };
        }
        button.hidden = !suggestion || !!last.error;
        buttons.forEach(function (b) { b.hidden = button.hidden; b.textContent = button.textContent; });
        var holders = elements('[data-checkout-rewards]');
        var holder = holders[0] || global.document.createElement('div'); holder.replaceChildren();
        var track = el('div', 'clp-checkout__track' + (config.automatic ? ' is-estimated' : '')), fill = el('div', 'clp-checkout__fill');
        var stops = [{ amount: 0, position: 0 }].concat(rewards, [{ amount: thresholds.max, position: 100 }]);
        var dollars = Math.min(thresholds.max, Math.max(0, total / 100));
        var upper = Math.max(1, stops.findIndex(function (s) { return s.amount >= dollars; }));
        var a = stops[upper - 1], b = stops[upper];
        fill.style.width = (a.position + (dollars - a.amount) / (b.amount - a.amount) * (b.position - a.position)) + '%';
        track.setAttribute('role', 'progressbar'); track.setAttribute('aria-label', config.automatic ? 'Pre-discount subtotal progress; eligibility confirmed in cart' : 'Reward progress'); track.setAttribute('aria-valuemin', '0'); track.setAttribute('aria-valuemax', String(thresholds.max)); track.setAttribute('aria-valuenow', String(dollars));
        track.appendChild(fill);
        rewards.forEach(function (r) {
          var reached = total >= r.amount * 100, milestone = el('div', 'clp-checkout__milestone' + (reached ? ' is-unlocked' : ''));
          milestone.style.left = r.position + '%';
          milestone.appendChild(el('span', 'clp-checkout__marker'));
          milestone.appendChild(el('span', 'clp-checkout__reward', r.label));
          milestone.appendChild(el('span', 'clp-checkout__amount', money(r.amount * 100)));
          if (next === r) milestone.appendChild(el('span', 'clp-checkout__away', text('away', '[amount] away').replace('[amount]', money(gap))));
          track.appendChild(milestone);
        });
        holder.appendChild(track);
        if (!next) holder.appendChild(el('p', 'clp-checkout__unlocked', config.automatic ? 'Subtotal targets reached. Rewards confirmed in cart.' : text('unlocked', 'All rewards unlocked')));
        holders.slice(1).forEach(function (other) { other.replaceChildren(); Array.from(holder.childNodes).forEach(function (child) { other.appendChild(child.cloneNode(true)); }); });
        if (global.ClutchLoopCheckoutView) global.ClutchLoopCheckoutView.render(node, { products: products, total: total, rewards: rewards, thresholds: thresholds, money: money, itemMoney: context.itemMoney || money, offer: button.hidden ? null : visibleOffer, add: add, automatic: config.automatic });
        elements('[data-checkout-savings]').forEach(function (savings) {
          var saved = Math.max(0, value - total);
          savings.hidden = config.automatic && saved === 0;
          savings.textContent = text('saving', 'Saving [amount]').replace('[amount]', money(saved));
        });
        var status = node.querySelector('[data-checkout-status]'); status.hidden = !last.error; status.textContent = last.error;
        elements('[data-checkout-shipping-note]').forEach(function (note) {
          note.hidden = true;
          note.textContent = '';
        });
        var shipping = node.querySelector('[data-checkout-shipping-text]');
        if (shipping) shipping.textContent = !config.automatic && total >= thresholds.shipping * 100 ? text('shippingDone', 'Free shipping') : text('shippingPending', 'Free US shipping over [amount]').replace('[amount]', money(thresholds.shipping * 100));
        return last;
      }
    };
  }
  global.ClutchLoopCheckout = { mount: mount };
})(typeof window !== 'undefined' ? window : globalThis);
